module.exports = __webpack_public_path__ + "img/home-activity-bg.8b5cb92b.svg";